import { useEffect, useRef, useState } from "react";
import { finishedSince } from "../../core/data/auditsPage";

// Same gap as the running screen's refresh.
const POLL_MS = 3000;

// While any Snapshot is running, reloads the list quietly every 3 seconds
// (one reload at a time), so the rows and "Gathering now" stay current. Stops
// when nothing is running. Returns a number that goes up each time a running
// Snapshot finishes or is stopped, for reloading the roll-up then (only then).
export default function useLiveJobs(jobs, reloadJobs) {
  const running = jobs.some(j => j.status === "running");

  useEffect(() => {
    if (!running) return undefined;
    let timer = null;
    let stopped = false;
    const next = () => {
      timer = setTimeout(async () => {
        try { await reloadJobs(); } catch (error) { console.error("reloadJobs", error); }
        if (!stopped) next();
      }, POLL_MS);
    };
    next();
    return () => { stopped = true; clearTimeout(timer); };
  }, [running, reloadJobs]);

  const before = useRef(jobs);
  const [finished, setFinished] = useState(0);
  useEffect(() => {
    if (finishedSince(before.current, jobs)) setFinished(n => n + 1);
    before.current = jobs;
  }, [jobs]);

  return finished;
}
